import { ConfigurationProfile as ConfigurationProfileModel } from '@rocksoft/mdm-sdk-v2';
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';

export interface ConfigurationProfile extends ConfigurationProfileModel {
  udid: string;
}

export type ConfigurationProfileState = EntityState<ConfigurationProfile>;

export function selectId(configurationProfile: ConfigurationProfile): string {
  return `${configurationProfile.udid}-${configurationProfile.payloadUUID}`;
}

export const adapter: EntityAdapter<ConfigurationProfile> = createEntityAdapter<ConfigurationProfile>({
  selectId,
});

export const initialState: ConfigurationProfileState = adapter.getInitialState();
